import { useForm, Controller } from 'react-hook-form';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { filterEmptyFields } from '../../utils/formUtils';
import {
  Button,
  InputLabel,
  DialogActions,
  DialogContent,
  IconButton,
  DialogTitle,
  TextField,
  Typography,
  Dialog,
  Backdrop,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import Select from 'react-select';
import InputAdornment from '@mui/material/InputAdornment';
import Modal from '../../components/common/Modal';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useNotification } from 'hooks/useNotification';
import { keywordAPI } from 'services/admin';

function ModalKeywords(props) {
  // const [active, setActive] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [selectErrorRequired, setSelectErrorRequired] = useState('');
  const [isKeywordsLoading] = useState(false);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [confirmDialogAction, setConfirmDialogAction] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
  });
  const { setNotify } = useNotification();
  const [isLoadingModalConfirmation, setIsLoadingModalConfirmation] =
    useState(false);
  const { showConfirmationButton } = useState(true);
  // const [selectedName, setSelectedName] = useState('');
  const {
    formState: { isDirty, isValid },
    handleSubmit,
    reset,
    setValue,
    getValues,
    control,
  } = useForm({ mode: 'onBlur' });

  async function postData(bodyData) {
    setIsLoading(true);

    // bodyData.createdBy = { keywordId: session.getIdToken().payload.sub, name: session.getIdToken().payload.username }; //TODO: verificar se manda o name do cognito
    // bodyData.updatedBy = {"keywordId": session.getIdToken().payload.sub, "name": session.getIdToken().payload.name} //TODO: verificar se manda o name do cognito
    const data = {
      body: bodyData,
    };

    return keywordAPI
      .post(data)
      .then(() => {
        setNotify({
          isOpen: true,
          message: `Palavra-chave criada com sucesso!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        props.getKeywords();
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  async function putData(bodyData) {
    setIsLoading(true);
    // bodyData.createdBy = { keywordId: session.getIdToken().payload.sub, name: session.getIdToken().payload.username }; //TODO: verificar se manda o name do cognito

    const data = {
      body: bodyData,
    };

    return keywordAPI
      .put(`/${props.keyword.id}`, data)
      .then(resp => {
        setNotify({
          isOpen: true,
          message: `Palavra-chave "${props.keyword.key}" atualizada com sucesso!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoading(false);
        props.getKeywords();
      })
      .catch(error => {
        console.log(error);
        setIsLoading(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  async function deleteData() {
    setIsLoadingModalConfirmation(true);

    keywordAPI
      .del(`/${props.keyword.id}`)
      .then(resp => {
        setNotify({
          isOpen: true,
          message: `Palavra-chave "${props.keyword.key}" removida!`,
          type: 'success',
          title: 'Sucesso!',
        });
        setIsLoadingModalConfirmation(false);
        setConfirmDialogAction({ isOpen: false });
        props.onClose();
        props.getKeywords();
      })
      .catch(error => {
        console.log(error);
        setIsLoadingModalConfirmation(false);
        const errorJson = error.request.response;
        const parseJson = JSON.parse(errorJson);
        setConfirmDialogAction({ isOpen: false });

        setNotify({
          isOpen: true,
          message: parseJson.message,
          type: 'error',
          title: 'Ops! Algo deu errado...',
        });
      });
  }

  useEffect(() => {
    //On Modal Open
    if (props.open === true) {
      // Set initial values
      setValue('key', props.keyword.key ? props.keyword.key : '');
      setSelectedKeywords(
        props.keyword.values
          ? props.keyword.values.map(word => ({ label: word, value: word }))
          : []
      );
    }
  }, [props.open]);

  const onSubmit = data => {
    const formValues = getValues();
    //Prepare
    formValues['values'] = selectedKeywords.map(value => value.value);
    // Remove fields with empty values
    let filteredFormValues = filterEmptyFields(formValues);

    if (props.action === 'edit') {
      putData(filteredFormValues).then(() => {
        closeModal();
      });
    } else if (props.action === 'create') {
      postData(filteredFormValues)
        .then(() => {
          // Reset all fields after post
          closeModal();
          // setActive(undefined)
        })
        .catch(error => {
          console.log(error);
          //TODO: o que acontece se der erro na inserção?
        });
    }
  };

  function closeModal() {
    reset();
    setSelectedKeywords([]);
    props.onClose();
  }

  return (
    <>
      <Dialog open={props.open} onClose={closeModal}>
        <Backdrop open={isLoading} style={{ zIndex: 9999 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <Form onSubmit={handleSubmit(onSubmit)} style={{ width: 480 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingTop: 12,
            }}>
            <DialogTitle
              style={{ lineHeight: 0, color: 'rgba(16, 24, 40, 1)' }}>
              {props.action === 'edit'
                ? 'Editar palavra-chave'
                : 'Criar palavra-chave'}
            </DialogTitle>
          </div>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: theme => theme.palette.grey[500],
            }}>
            <CloseIcon />
          </IconButton>

          <Typography
            style={{ paddingRight: 24, paddingTop: 4, paddingLeft: 24 }}>
            Preencha as informações de uma nova palavra-chave.
          </Typography>
          <DialogContent>
            <Form.Group className="mb-3" controlId="formKey">
              <InputLabel className="form-label" htmlFor="key">
                Chave
              </InputLabel>

              <Controller
                name={'key'}
                control={control}
                rules={{
                  required: 'A chave é obrigatória',
                }}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <TextField
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    placeholder="Escreva uma chave."
                    variant="standard"
                    onBlur={onBlur}
                    disabled={
                      props.keyword.deleted === true
                        ? true
                        : props.keyword.deleted === 'true'
                          ? true
                          : false
                    }
                    id="keyword_key"
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formWord">
              <div className="label-content">
                <label className="max-char-name">40 caracteres</label>
                <InputLabel className="form-label" htmlFor="word">
                  Adicionar palavra
                </InputLabel>
              </div>
              <Controller
                name={'word'}
                control={control}
                rules={{
                  minLength: { value: 3, message: 'Mínimo de 3 caracteres' },
                  maxLength: { value: 40, message: 'Máximo de 40 caracteres' },
                }}
                render={({
                  field: { onChange, value, onBlur, ref },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <TextField
                    id="keyword_value"
                    helperText={
                      error ? (
                        <span style={{ fontSize: '16px' }}>
                          {' '}
                          {error.message}{' '}
                        </span>
                      ) : null
                    }
                    error={!!error}
                    onChange={e => {
                      onChange(e);
                      // setSelectedName(e.target.value)
                    }}
                    value={value}
                    fullWidth
                    placeholder="Escreva uma palavra chave."
                    variant="standard"
                    onBlur={e => {
                      if (selectedKeywords.length < 1) {
                        setSelectErrorRequired('values');
                      } else {
                        setSelectErrorRequired('');
                      }
                      onBlur(e);
                    }}
                    inputRef={ref}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="add"
                            onClick={() => {
                              if (value?.length) {
                                const valueExists = selectedKeywords.some(
                                  keyword => keyword.label === value
                                );
                                // Adicione o objeto à lista de selectedKeywords
                                if (!valueExists) {
                                  setSelectedKeywords(prevKeywords => [
                                    ...prevKeywords,
                                    { label: value, value: value },
                                  ]);
                                  // Limpe o valor do campo
                                  onChange('');
                                  setSelectErrorRequired('');
                                }
                              }
                            }}
                            edge="end"
                            color="primary"
                            sx={{
                              right: 15,
                            }}>
                            <AddIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                    disabled={
                      props.keyword.deleted === true
                        ? true
                        : props.keyword.deleted === 'true'
                          ? true
                          : false
                    }
                  />
                )}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formKeywords">
              <InputLabel
                className="form-label"
                id="select-standard-label"
                htmlFor="values">
                Palavras-chave
              </InputLabel>
              <Controller
                name={'values'}
                control={control}
                render={({
                  field: { onChange, value, onBlur },
                  fieldState: { error, invalid, isTouched, isDirty },
                  formState,
                }) => (
                  <Select
                    id="keyword_values_inserted"
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        '&:hover': {
                          borderColor: '#464646',
                        },
                        borderRadius: '5px',
                        width: 'auto',
                        padding: 0,
                        margin: 0,
                      }),
                      singleValue: base => ({
                        ...base,
                        // padding: 5,
                        borderRadius: 6,
                        color: '#B7B5BE',
                        fontSize: '15px',
                        display: 'flex',
                      }),
                    }}
                    theme={theme => ({
                      ...theme,
                      borderRadius: 0,
                      colors: {
                        ...theme.colors,
                        primary25: '#e9e9ea',
                        primary: '#0A6CCF',
                        width: 'auto',
                      },
                    })}
                    className="basic-single"
                    classNamePrefix="select"
                    isDisabled={
                      props.keyword.deleted === true
                        ? true
                        : props.keyword.deleted === 'true'
                          ? true
                          : false
                    }
                    openMenuOnClick={
                      props.keyword.deleted === true
                        ? false
                        : props.keyword.deleted === 'true'
                          ? false
                          : true
                    }
                    isSearchable={
                      props.keyword.deleted === true
                        ? false
                        : props.keyword.deleted === 'true'
                          ? false
                          : true
                    }
                    isMulti
                    placeholder="As palavras adicionadas aparecerão aqui."
                    //   options={selectedKeywords}
                    value={selectedKeywords}
                    components={{
                      Menu: () => null, // Remove menu
                      MenuList: () => null, // Remove menu list
                      DropdownIndicator: () => null, // Remove dropdown icon
                      IndicatorSeparator: () => null,
                    }}
                    isLoading={isKeywordsLoading}
                    onChange={selectedOption => {
                      onChange(selectedOption);
                      setSelectedKeywords(selectedOption);
                      // setSelectedName(e.target.value)
                    }}
                    // components={animatedComponents}
                  />
                )}
              />

              {selectErrorRequired === 'values' && (
                <p className="error" role="alert">
                  As palavras-chave são obrigatórias
                </p>
              )}
            </Form.Group>
          </DialogContent>
          <DialogActions style={{ padding: '0 24px 24px' }}>
            {props.action === 'edit' && (
              <Button
                id="keyword_remove_btn"
                style={{
                  color: 'rgba(52, 64, 84, 1)',
                  borderRadius: 8,
                  background: 'rgba(255, 255, 255, 1)',
                  borderColor: 'rgba(208, 213, 221, 1)',
                  padding: '10px 18px',
                  marginLeft: 12,
                  pointerEvents:
                    props.keyword.deleted === true
                      ? 'none'
                      : props.keyword.deleted === 'true'
                        ? 'none'
                        : '',
                }}
                onClick={() =>
                  setConfirmDialogAction({
                    isOpen: true,
                    title: `Remover ${props.keyword.key}?`,
                    subTitle: `Você está removendo a palavra-chave "${props.keyword.key}" permanentemente. Clique remover para confirmar.`,
                    confirmTextButton: 'Remover',
                    color: 'error',
                    children: (
                      <div className="modalRemoveItem">
                        <DeleteOutlineOutlinedIcon
                          color="error"
                          fontSize="8px"
                        />
                      </div>
                    ),
                    onConfirm: () => {
                      deleteData();
                    },
                    showConfirmationButton: { showConfirmationButton },
                    closeTextButton: 'Cancelar',
                  })
                }
                variant="contained"
                className={
                  props.keyword.deleted === true
                    ? 'disabled_inactive_button'
                    : props.keyword.deleted === 'true'
                      ? 'disabled_inactive_button'
                      : ''
                }>
                Remover
              </Button>
            )}
            <Button
              id="keyword_cancel_btn"
              style={{
                marginLeft: 12,
                color: 'rgba(52, 64, 84, 1)',
                borderRadius: 8,
                background: 'rgba(255, 255, 255, 1)',
                borderColor: 'rgba(208, 213, 221, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              onClick={() => {
                closeModal();
              }}>
              Cancelar
            </Button>
            <Button
              id="keyword_save_btn"
              style={{
                color: 'rgba(255, 255, 255, 1)',
                borderRadius: 8,
                marginLeft: 12,
                background: 'rgba(19, 97, 164, 1)',
                borderColor: 'rgba(19, 97, 164, 1)',
                padding: '10px 18px',
              }}
              variant="contained"
              type="submit"
              disabled={
                !isDirty ||
                !isValid ||
                selectedKeywords < 1 /*|| active === undefined*/
              }
              onClick={() => {}}
              className={
                props.keyword.deleted === true
                  ? 'disabled_save_button'
                  : props.keyword.deleted === 'true'
                    ? 'disabled_save_button'
                    : ''
              }>
              Salvar
            </Button>
          </DialogActions>
          <Modal
            confirmDialogAction={confirmDialogAction}
            setConfirmDialogAction={setConfirmDialogAction}
            isLoadingModalConfirmation={isLoadingModalConfirmation}
            setIsLoadingModalConfirmation={setIsLoadingModalConfirmation}
            showConfirmationButton={showConfirmationButton}
          />
        </Form>
      </Dialog>
    </>
  );
}

export default ModalKeywords;
